import game from '@/api/administrator/game-setting'
import claimed from '@/api/report/claimed'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
    ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
	preview(context, attrubutes = {}) {
		let params = Object.assign({
      page: context.state.pagination.page,
      perPage: context.state.pagination.perPage
		}, attrubutes)
		
    return claimed.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
	},
	store(context, data){
		return claimed.store(data)
	},
	getGameSetting(context) {
		return game.get({
			params: {
				fields: {
					game_settings: 'game_setting,game_setting_id,game_type_id'
				},
				page: -1
			},
			headers: {
				'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
			}
		})
	}
}